/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Actions_DeleteInputs */

const es_user_profile_api_keys_actions_delete = /** @type {(inputs: User_Profile_Api_Keys_Actions_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar clave API`)
};

const en_user_profile_api_keys_actions_delete = /** @type {(inputs: User_Profile_Api_Keys_Actions_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete API key`)
};

/**
* | output |
* | --- |
* | "Delete API key" |
*
* @param {User_Profile_Api_Keys_Actions_DeleteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_actions_delete = /** @type {((inputs?: User_Profile_Api_Keys_Actions_DeleteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Actions_DeleteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_actions_delete(inputs)
	return en_user_profile_api_keys_actions_delete(inputs)
});
export { user_profile_api_keys_actions_delete as "user.profile.api_keys.actions.delete" }